<template>
  <v-row dense no-gutters class="mt-2">
    <v-col cols="12">
      <v-system-bar color="primary" class="white--text" dark>
        Комментарии по конфигурации
      </v-system-bar>
      <config-comments-list :project="project" ></config-comments-list>
    </v-col>
  </v-row>
</template>

<script>
import { UI_SET_ACTIONS } from '@/store/actions/ui'
import ConfigCommentsList from '../../forms/configCommentsList.vue'

export default {
  name: 'projectDialogCard',
  components: {
    ConfigCommentsList
  },
  props: {
    project: {
      type: Object,
      default: function () {
        return {}
      }
    },
    activeTab: {
      type: String,
      default: null
    }
  },
  data () {
    return {
    }
  },
  watch: {
    activeTab (val) {
      this.setActions()
    }
  },
  methods: {
    setActions () {
      this.$store.dispatch(UI_SET_ACTIONS, {
        actionType: 'Переписка',
        actions: []
      })
    }
  },
  mounted () {
    this.setActions()
  }
}
</script>
